import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ApiFeatureConfig, ApiProfile } from './core/models/api-profile.model';
import { ApiProfileService } from './core/services/api-profile.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly apiProfileService = inject(ApiProfileService);

  isAuthenticationPage = this.router.url.startsWith('/qlcv');
  activeProfile: ApiProfile = this.apiProfileService.activeProfile;
  overviewFeatures: readonly ApiFeatureConfig[] = [];
  businessFeatures: readonly ApiFeatureConfig[] = [];

  constructor() {
    this.applyProfile(this.activeProfile);

    this.apiProfileService.activeProfile$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((profile) => {
        this.applyProfile(profile);
        this.changeDetectorRef.markForCheck();
      });

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.isAuthenticationPage = event.urlAfterRedirects.startsWith('/qlcv');
        this.changeDetectorRef.markForCheck();
      });
  }

  private applyProfile(profile: ApiProfile): void {
    this.activeProfile = profile;
    this.overviewFeatures = profile.features.filter(
      (feature) => feature.menuGroup === 'overview',
    );
    this.businessFeatures = profile.features.filter(
      (feature) => feature.menuGroup === 'business',
    );
  }
}
